import useCustomEffect from "../../../../../../hooks/useCustomEffect";
import ReferenceCheckFormView from "./ReferenceCheckFormView";

function ReferenceCheckForm({
  relations,
  fetchRelation,
  selectedStep,
  selectedStepIndex,
  setFlowData,
  submitError,
}) {
  /**
   * This effect will fetch the fields relation on mount.
   */
  useCustomEffect(() => {
    fetchRelation("fields");
  }, []);

  /**
   * This method will handle the on reference field change event
   * @param {int} referenceFieldId
   */
  function onReferenceFieldChange(referenceFieldId) {
    setFlowData((prev) => ({
      ...prev,
      steps: prev.steps.map((step) => {
        if (step.id === selectedStep.id) {
          return {
            ...step,
            reference_field_id: referenceFieldId,
          };
        }
        return step;
      }),
    }));
  }

  return (
    <ReferenceCheckFormView
      relations={relations}
      selectedStep={selectedStep}
      selectedStepIndex={selectedStepIndex}
      onReferenceFieldChange={onReferenceFieldChange}
      submitError={submitError}
    />
  );
}

export default ReferenceCheckForm;